import TextButton from "@/components/Common/TextButton";
import clsxm from "@/lib/clsxm";
import {FC, memo} from "react";
import {NavLink} from "react-router";

const NavButton: FC<
  {
    className?: string;
    text: string;
  } & (
    | {
        to: string;
        pointingToLandingPage?: boolean;
      }
    | {
        onClick(): void;
      }
  )
> = props => {
  return "to" in props ? (
    props.pointingToLandingPage ? (
      <a
        style={{
          textDecoration: "none",
        }}
        href={props.to}
        className="text-neutral-black hover:text-neutral-grey-dark flex cursor-pointer items-center justify-center text-lg font-bold transition-all duration-150 hover:scale-[1.02]">
        {props.text}
      </a>
    ) : (
      <NavLink
        to={props.to ?? "#"}
        style={{
          textDecoration: "none",
        }}>
        {({isActive}) => (
          <span
            className={clsxm(
              "flex items-center justify-center text-lg font-bold whitespace-nowrap transition-all duration-150",
              isActive
                ? "text-primary-dark-solid"
                : "text-neutral-black hover:text-neutral-grey-dark hover:scale-[1.02]",
              props.className,
            )}>
            {props.text}
          </span>
        )}
      </NavLink>
    )
  ) : (
    <TextButton
      onClick={props.onClick}
      className={clsxm(
        "enabled:text-neutral-black enabled:hover:text-neutral-grey-dark flex items-center justify-center text-lg font-bold hover:scale-[1.02]",
        props.className,
      )}
      text={props.text}
    />
  );
};

export default memo(NavButton);
